export const API_URL = process.env.VUE_APP_API_URL;
export const GOOGLE_API_KEY = process.env.VUE_APP_GOOGLE_API_KEY;
export const userTokenStorageKey = 'jwt-token';
